import { LEAD_COLLECTOR_STEPS } from '@entities/leadCollector';
import FolderImage from '@/shared/assets/images/folder.png';
import { Button } from '@shared/ui/kit';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

interface WelcomeScreenProps {
  setStep: (step: number) => void;
}

export const WelcomeScreen = ({ setStep }: WelcomeScreenProps) => (
  <div {...stylex.props(styles.container)}>
    <img {...stylex.props(styles.image)} src={FolderImage} height={145} alt="Выберите шаблон" />

    <div {...stylex.props(styles.description)}>
      <p {...stylex.props(styles.title)}>Выберите шаблон</p>
      <p {...stylex.props(styles.subTitle)}>
        Выберите шаблон из существующих — его можно отредактировать или оставить как есть. Либо создайте новый шаблон
        под свое мероприятие
      </p>
    </div>

    <div {...stylex.props(styles.actions)}>
      <Button variant="secondary" onClick={() => setStep(LEAD_COLLECTOR_STEPS.CREATE_FORM)} size="small">
        Создать новый
      </Button>
      <Button variant="accent" onClick={() => setStep(LEAD_COLLECTOR_STEPS.CHOOSE_FORM)} size="small">
        Выбрать шаблон
      </Button>
    </div>
  </div>
);
